var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrevSlide(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 10,
    viewBox: "0 0 12 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.567 4.15891H3.15618L5.92585 1.38924L4.73656 0.199951L1.12581 3.8107C0.810458 4.12615 0.633301 4.55394 0.633301 4.99999C0.633301 5.44603 0.810458 5.87382 1.12581 6.18927L4.73656 9.80002L5.92585 8.61074L3.15618 5.84107H11.567V4.15891Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrevSlide);
export default __webpack_public_path__ + "static/media/prev-slide.ae359186057ae419d9906e2bd529febf.svg";
export { ForwardRef as ReactComponent };